<template>
	<div>
		<el-table :data="list" style="width: 100%;margin-top: 16px;">
			<el-table-column label="昵称/手机号" >
				<template slot-scope="scope2">
					<span>{{scope2.row.name}}/{{scope2.row.phone_number}}</span>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" prop="created_at">
			</el-table-column>
			<el-table-column label="修改时间" prop="updated_at">
			</el-table-column>
			<el-table-column label="账号类型">
				<template slot-scope="scope2">
					<span>{{versionTypeMap[scope2.row.version_type]}}</span>
				</template>
			</el-table-column>
		</el-table>
		
		<!-- 分页 -->
		<div style="padding: 15px 0; text-align: right;">
			<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
				:current-page="pagination.page" :page-size="pagination.per_page"
				layout="total, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pagination: {
					id: '',
					page: 1,
					per_page: 10,
					total: 0
				},
				versionTypeMap: {
					1: 980,
					2: 1980,
					3: 2980,
					6: 3980
				},
				id: '',
				list: []
			}
		},
		methods: {
			getList() {
				this.$axios.get('admin-dls-user-list', this.pagination).then(res => {
					if (!res.code) {
						this.$message.error('列表获取失败')
						return
					}
					this.list = res.data.data;
					this.pagination.total = res.data.total;
					// this.search.total = res.data.total;
				});
			},
			handleCurrentChange(page) {
				this.pagination.page = page;
				this.getList();
			}
		},
		mounted() {
			this.pagination.id = this.$route.params.id
			this.getList()
			// console.log(this.$route)
		}
	}
</script>

<style>
</style>
